import Vue from 'vue'

const actions = {

  /**
   * @param context
   */
  async loadData (context) {
    await context.dispatch('getRequestsList')
    context.dispatch('activateWsListener')
  },
  async getRequestsList (context) {
    await Vue.axios.get('request')
      .then(response => {
        context.commit('SET_REQUESTS_FAILED_LIST', response.data)
      })
  },
  activateWsListener (context) {
    Vue.$io.socket.off('request_failed')
    Vue.$io.socket.on('request_failed', (data) => {
      if (!this.state.User.liveMode.failedRequests) return
      context.commit('ADD_REQUEST_FAILED', data)
    })
  },
  markFailedRequestsAsSeen (context) {
    context.commit('MARK_FAILED_AS_SEEN')
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/request/request.actions.js
// module id = null
// module chunks = 